webpackJsonp([86466169170238],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.regulatoryQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _graphql = __webpack_require__(22);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _path = __webpack_require__(165);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoIcon = __webpack_require__(26);
	
	var _logoIcon2 = _interopRequireDefault(_logoIcon);
	
	var _image_thumbnail = __webpack_require__(49);
	
	var _image_thumbnail2 = _interopRequireDefault(_image_thumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// find a post title by path
	var findNode = function findNode(path, data) {
	  return data.allMarkdownRemark.edges.map(function (edge) {
	    return edge.node.frontmatter;
	  }).filter(function (r) {
	    return r.path === path;
	  }).pop();
	};
	
	function Template(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  var post = data.markdownRemark;
	  // const related = post.frontmatter.related ? post.frontmatter.related.map(r => findNode(r.post, data)) : []
	
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Research | ' + post.frontmatter.title }),
	    _react2.default.createElement(
	      'div',
	      { className: 'navbar navbar-expand-lg navbar-dark' },
	      _react2.default.createElement('div', { className: 'navbar-blue' }),
	      _react2.default.createElement('div', { className: 'navbar-teal' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'page-header' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'page-header-text', xs: { size: 12 }, md: { size: 9 } },
	            _react2.default.createElement(
	              'header',
	              { className: 'bebas' },
	              'Height Capital Markets'
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Insights, Elevated.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-circular-header' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              _react2.default.createElement('img', { src: _logoIcon2.default })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'page-content research' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'page-copy regulatory', xs: { size: 12 }, md: { size: 10 } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              post.frontmatter.title
	            ),
	            _react2.default.createElement('div', { className: 'research-post-copy', dangerouslySetInnerHTML: { __html: post.html } })
	          )
	        )
	      )
	    )
	  );
	}
	
	var regulatoryQuery = exports.regulatoryQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-regulatory-js-2bb3ee64124e7951a856.js